import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import 'virtual:svg-icons-register'

import App from './App.vue'
import uView from '@/uni_modules/vk-uview-ui'
import SvgIcon from '@/components/svg_icon/svg_icon.vue'

export function createApp() {
  const app = createSSRApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(uView)
  app.component('SvgIcon', SvgIcon)

  return {
    app,
  }
}
